import React from 'react'
import { css } from '@emotion/core'
import { bool, func } from 'prop-types'
import { getSessionId } from '@fs/zion-session'
import { PersonType } from '../../../../shared/propTypes/personDataProps'
import WcfViewEnum from '../../../../shared/propTypes/wcfViewEnumProps'
import LineType from '../../../../shared/propTypes/lineEnumProps'
import Relative from './Relative'
import straightLine from '../../assets/straightNormalLine.svg'
import bottomTopRight from '../../assets/bottomLeftTopRightLine.svg'
import bottomTopLeft from '../../assets/bottomRightTopLeftLine.svg'
import endLeft from '../../assets/endLeft.svg'
import endRight from '../../assets/endRight.svg'
import startLines from '../../assets/startLines.svg'
import startRight from '../../assets/startRight.svg'
import startLeft from '../../assets/startLeft.svg'
import startLeftDark from '../../assets/startLeftDark.svg'
import startRightDark from '../../assets/startRightDark.svg'
import straightLineDark from '../../assets/straightLineDark.svg'
import bottomTopRightDark from '../../assets/bottomTopRightDark.svg'
import bottomTopLeftDark from '../../assets/bottomTopLeftDark.svg'
import { useAncestorImageData } from '../../../global/hooks'

export default function Row({
  parentOne,
  parentTwo,
  onParentOneClick,
  onParentTwoClick,
  parentOneActive,
  parentTwoActive,
  lineType,
  view,
}) {
  const sessionId = getSessionId()
  const personOneImageLink = useAncestorImageData({ ...parentOne, sessionId })
  const personTwoImageLink = useAncestorImageData({ ...parentTwo, sessionId })
  const createPlaceHolder = (isParentOne) => {
    const placeHolderPerson = {
      name: '',
      surname: '',
      gender: '',
      lifespan: '',
      personId: null,
      atn: isParentOne ? -2 : 1,
    }
    return placeHolderPerson
  }

  if (!parentOne) {
    parentOne = createPlaceHolder(true)
  }

  if (!parentTwo) {
    parentTwo = createPlaceHolder(false)
  }

  const row = css`
    display: flex;
    align-items: start;
    height: 94px;
    ${lineType === 'startLines' ? `background-image: url(${startLines})` : ``};
    ${lineType === 'startLines' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'startLines' ? `background-position: calc(52%) 50px` : ``};
    ${lineType === 'startRight' ? `background-image: url(${startRight})` : ``};
    ${lineType === 'startRight' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'startRight' ? `background-position: calc(55%) 48px` : ``};
    ${lineType === 'startRightDark' ? `background-image: url(${startRightDark})` : ``};
    ${lineType === 'startRightDark' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'startRightDark' ? `background-position: calc(52%) 48px` : ``};
    ${lineType === 'startLeft' ? `background-image: url(${startLeft})` : ``};
    ${lineType === 'startLeft' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'startLeft' ? `background-position: calc(45%) 50px` : ``};
    ${lineType === 'startLeftDark' ? `background-image: url(${startLeftDark})` : ``};
    ${lineType === 'startLeftDark' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'startLeftDark' ? `background-position: calc(45.5%) 50px` : ``};
    ${lineType === 'endRight' ? `background-image: url(${endRight})` : ``};
    ${lineType === 'endRight' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'endRight' ? `background-position: calc(49.7%) 50px` : ``};
    ${lineType === 'endLeft' ? `background-image: url(${endLeft})` : ``};
    ${lineType === 'endLeft' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'endLeft' ? `background-position: calc(49.7%) 50px` : ``};
    ${lineType === 'bottomTopLeft' ? `background-image: url(${bottomTopLeft})` : ``};
    ${lineType === 'bottomTopLeft' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'bottomTopLeft' ? `background-position: calc(49.7%) 50px` : ``};
    ${lineType === 'bottomTopLeftDark' ? `background-image: url(${bottomTopLeftDark})` : ``};
    ${lineType === 'bottomTopLeftDark' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'bottomTopLeftDark' ? `background-position: calc(49.7%) 50px` : ``};
    ${lineType === 'bottomTopRight' ? `background-image: url(${bottomTopRight})` : ``};
    ${lineType === 'bottomTopRight' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'bottomTopRight' ? `background-position: calc(49.7%) 50px` : ``};
    ${lineType === 'bottomTopRightDark' ? `background-image: url(${bottomTopRightDark})` : ``};
    ${lineType === 'bottomTopRightDark' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'bottomTopRightDark' ? `background-position: calc(49.7%) 50px` : ``};
    ${lineType === 'straightLeft' ? `background-image: url(${straightLine})` : ``};
    ${lineType === 'straightLeft' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'straightLeft' ? `background-position: calc(40.5%) 50px` : ``};
    ${lineType === 'straightLeftDark' ? `background-image: url(${straightLineDark})` : ``};
    ${lineType === 'straightLeftDark' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'straightLeftDark' ? `background-position: calc(40.5%) 50px` : ``};
    ${lineType === 'straightRight' ? `background-image: url(${straightLine})` : ``};
    ${lineType === 'straightRight' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'straightRight' ? `background-position: calc(59%) 50px` : ``};
    ${lineType === 'straightRightDark' ? `background-image: url(${straightLineDark})` : ``};
    ${lineType === 'straightRightDark' ? `background-repeat: no-repeat` : ``};
    ${lineType === 'straightRightDark' ? `background-position: calc(59%) 50px` : ``};
    @media (max-width: 375px) {
      ${lineType === 'straightRightDark' ? 'background-position: calc(57%) 50px' : ``};
    }
    @media (max-width: 768px) {
      ${lineType === 'straightLeftDark' ? 'background-position: calc(46%) 50px' : ``};
      ${lineType === 'straightRightDark' ? 'background-position: calc(59%) 50px' : ``};
    }
    @media (max-width: 812px) {
      ${lineType === 'straightLeftDark' ? 'background-position: calc(46.5%) 50px' : ``};
      ${lineType === 'straightRightDark' ? 'background-position: calc(53%) 50px' : ``};
    }
    @media (max-width: 1024px) {
      ${lineType === 'straightLeftDark' ? 'background-position: calc(41.5%) 50px' : ``};
      ${lineType === 'straightRightDark' ? 'background-position: calc(59%) 50px' : ``};
    }
  `

  const Person = ({ person, userImage, active, clickCallback }) => {
    return (
      <div
        onClick={() => {
          if (clickCallback) {
            clickCallback(person.personId)
          }
        }}
        onKeyPress={() => {
          if (clickCallback) {
            clickCallback(person.personId)
          }
        }}
        tabIndex={0}
        role="button"
        css={{ outline: 'none' }}
      >
        <Relative
          isSelf={false}
          name={person.name}
          lineType={lineType}
          surname={person.surname}
          gender={person.gender}
          lifeSpan={person.lifespan}
          userImage={userImage}
          atn={person.atn}
          view={view}
          clickable={!!clickCallback}
          faded={!active}
        />
      </div>
    )
  }

  return (
    <div css={row}>
      <Person
        person={parentOne}
        userImage={personOneImageLink}
        active={parentOneActive}
        clickCallback={onParentOneClick}
      />
      <Person
        person={parentTwo}
        userImage={personTwoImageLink}
        active={parentTwoActive}
        clickCallback={onParentTwoClick}
      />
    </div>
  )
}
Row.propTypes = {
  parentOne: PersonType,
  parentTwo: PersonType,
  parentOneActive: bool,
  parentTwoActive: bool,
  onParentOneClick: func,
  onParentTwoClick: func,
  lineType: LineType,
  view: WcfViewEnum,
}
